import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";

export const updateSiteMapArticleListMetaData = (ctx: IFetchContext<IRPRequestMeta>) => (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
    const categorySlug = ctx.match.params?.categorySlug;
    const categoryObj = getState().siteMap.articleCategories?.find((category) => category.slug === categorySlug);

    let page = parseInt(ctx.route.query.page as string, 10);
    page = isNaN(page) ? 1 : page;
    const pageSuffix = page > 1 ? ` (strona ${page})` : "";

    const title = `Mapa strony - Artykuły - ${concatWithBrandName(categoryObj ? ` kategoria ${categoryObj.name}${pageSuffix} - ` : "")}`;
    const description = concatWithBrandName(
        `Mapa strony - Artykuły - wszystkie artykuły z kategorii ${categoryObj ? categoryObj.name : ""} w Strefie Wiedzy portalu${pageSuffix}`
    );
    dispatch(updateMetaData({title, description, pathname: ctx.route.pathname, pageNumber: page}));

    return Promise.resolve();
};
import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";

export const updateSiteMapArticleListMetaData = (ctx: IFetchContext<IRPRequestMeta>) => (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
    const categorySlug = ctx.match.params?.categorySlug;
    const categoryObj = getState().siteMap.articleCategories?.find((category) => category.slug === categorySlug);

    let page = parseInt(ctx.route.query.page as string, 10);
    page = isNaN(page) ? 1 : page;
    const pageSuffix = page > 1 ? ` (strona ${page})` : "";

    const title = `Mapa strony - Artykuły - ${concatWithBrandName(categoryObj ? ` kategoria ${categoryObj.name}${pageSuffix} - ` : "")}`;
    const description = concatWithBrandName(
        `Mapa strony - Artykuły - wszystkie artykuły z kategorii ${categoryObj ? categoryObj.name : ""} w Strefie Wiedzy portalu${pageSuffix}`
    );
    dispatch(updateMetaData({title, description, pathname: ctx.route.pathname, pageNumber: page}));

    return Promise.resolve();
};
